import React from 'react';
type AmbientLightProps = {
  /**
   * Placement preset for the glow pool(s) within a relatively-positioned,
   * overflow-hidden parent section.
   */
  variant?: 'top' | 'corner' | 'split' | 'center';
  /** Adds a faint hairline of light along the top edge of the section. */
  seam?: boolean;
  className?: string;
};
/**
 * Decorative ambient lighting for dark sections — soft, blurred caramel/cream
 * glow orbs that breathe slowly. Purely decorative and aria-hidden.
 * Place as the first child of a `relative overflow-hidden` container.
 */
export function AmbientLight({
  variant = 'top',
  seam = false,
  className = ''
}: AmbientLightProps) {
  return <div aria-hidden className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`} data-id="element-44" data-mp="cugblg6st4mg">
      {seam && <span className="light-seam" data-id="element-45" data-mp="2xjcg6i9c3is9" />}

      {variant === 'top' && <span className="light-orb animate-light-breath" style={{
      width: 620,
      height: 620,
      top: -260,
      left: '50%',
      transform: 'translateX(-50%)'
    }} data-id="element-46" data-mp="2xghwisy5a1zw" />}

      {variant === 'corner' && <>
          <span className="light-orb animate-light-breath" style={{
        width: 520,
        height: 520,
        top: -200,
        right: -160
      }} data-id="element-47" data-mp="1s2rdqih4nklg" />
          <span className="light-orb light-orb--cream animate-light-breath-slow" style={{
        width: 420,
        height: 420,
        bottom: -220,
        left: -140
      }} data-id="element-48" data-mp="1icfw5t4itcw3" />
        </>}

      {variant === 'split' && <>
          <span className="light-orb animate-light-breath" style={{
        width: 480,
        height: 480,
        top: -160,
        left: -120
      }} data-id="element-49" data-mp="1dd38x79qm3sz" />
          <span className="light-orb animate-light-breath-slow" style={{
        width: 480,
        height: 480,
        bottom: -180,
        right: -120
      }} data-id="element-50" data-mp="14cnawdbrjovi" />
        </>}

      {variant === 'center' && <span className="light-orb animate-light-breath" style={{
      width: 760,
      height: 760,
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    }} data-id="element-51" data-mp="2wdkmbkoz9glo" />}
    </div>;
}